import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'deepValue',
})
export class DeepValuePipe implements PipeTransform {
  transform(obj: any, keys: any[]): any {
    return keys.reduce((xs, x) => {
      if (Array.isArray(x)) {
        return x.reduce((o, k) => (o && o[k] ? o[k] : null), xs);
      }
      return xs && xs[x] ? xs[x] : null;
    }, obj);
  }
}
